module.exports = __webpack_public_path__ + "img/data.f5e5b801.svg";